var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FdAlert',{attrs:{"dismissible":""}},[_vm._v("\n    Default dismissable alert. Click on the close button.\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }